import React, { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { closeModal } from '../../../../redux/slices/modal';
import { DELETE_TILE } from '../../../../utils/apollo/tiles';
import {
  IDeleteTileMutation,
  IDeleteTileMutationVariables,
} from '../../../../utils/apollo/graphqlSchema';
import { selectModalData } from '../../../../redux/selectors/modal';
import { deleteTile } from '../../../../redux/slices/tiles';
import toastMessage from '../../../../utils/toastMessage';
import ConfirmationModal from '../../../../components/ConfirmationModal';

const DeleteTileModal = () => {
  const dispatch = useAppDispatch();
  const id = useAppSelector(selectModalData);

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const handleMutationComplete = () => {
    dispatch(deleteTile({ id }));
    handleClose();

    toastMessage({
      message: 'Tile has been removed',
      type: 'info',
    });
  };

  const [deleteTileMutation, { loading }] = useMutation<
    IDeleteTileMutation,
    IDeleteTileMutationVariables
  >(DELETE_TILE, {
    onCompleted: handleMutationComplete,
  });

  const handleDelete = () => {
    deleteTileMutation({
      variables: {
        input: {
          id,
        },
      },
    });
  };

  return (
    <ConfirmationModal
      open
      onClose={handleClose}
      onSubmit={handleDelete}
      header={'Delete Confirmation'}
      confirmActionLabel={'Delete'}
      disabled={loading}
      trackContext="tiles"
      trackConfirmAction="delete - confirm"
      trackCancelAction="delete - cancel"
    >
      Do you want to delete a tile? This action cannot be undone.
    </ConfirmationModal>
  );
};

export default DeleteTileModal;
